// extracted by mini-css-extract-plugin
export default {"title":"GeneralSettingsForm_title__eVyKF"};